
import {
  Component, Prop, Vue, Watch,
} from 'nuxt-property-decorator'
import {
  ProjectProperties, Section,
} from 'fsxa-api'
import { FSXARichText } from 'fsxa-pattern-library'
import BaseLink from '../base/BaseLink.vue'
import BaseButton from '../base/BaseButton.vue'
import BasePicture from '../base/BasePicture.vue'
import IImage from '../../shared/general/interfaces/IImage'
import { mapImage } from '../../shared/general/services/ImageService'
import Paragraph from '../fsxa/richtext/Paragraph.vue'
import { ILink } from '../../shared/general/interfaces/ILink'
import getLinkObject from '../../shared/fsxa/services/LinkService'

export interface IGeoTargetingInfo {
  matchedCountry ?: Section
  goToLabel ?: string
  goToLink ?: string
}

@Component({
  name: 'TheGeoTargeting',
  components: {
    BaseLink,
    BaseButton,
    BasePicture,
    FSXARichText,
    BaseIcon: () => import('../base/BaseIcon.vue'),
  },
})
export default class TheGeoTargeting extends Vue {
  @Prop({ required: true }) globalSettings! : ProjectProperties | null

  @Prop({ required: true }) getUrlByPageId! : Function

  @Prop({ required: true }) geoTargetingInfo! : IGeoTargetingInfo

  private geoTargetingVisible : boolean = false

  private modalVisible : boolean = false

  async mounted () {
    const scrollbarWidth = window.innerWidth - document.body.offsetWidth
    await setTimeout(() => { this.geoTargetingVisible = true })

    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${scrollbarWidth}px`,
    )
  }

  private get backgroundImage () : IImage {
    return mapImage(this.globalSettings?.data?.ps_gt_backgroundimage)
  }

  private get logo () : IImage {
    return mapImage(
      this.globalSettings?.data?.ps_gt_logo,
      this.globalSettings?.data?.ps_gt_logo_alt_text,
      this.globalSettings?.data?.ps_gt_logo_alt_text,
    )
  }

  private get description () : string {
    return this.globalSettings?.data?.ps_gt_description
  }

  private get modalSwitch () : string {
    return this.globalSettings?.data?.ps_gt_label_modalswitch
  }

  private get recommendationLabel () : string {
    return this.globalSettings?.data?.ps_gt_label_recommendation
  }

  private get stayButtonLabel () : string {
    return this.globalSettings?.data?.ps_gt_label_dekracom_btn
  }

  private get modalText () : FSXARichText[] | undefined {
    return this.globalSettings?.data?.ps_gt_text_modal?.map(
      (text : Paragraph) => text?.content,
    )
  }

  private get footerNavLinks () : ILink[] {
    return this.globalSettings?.data.ps_footer?.pt_nav_linklist?.map(
      (item : any) => getLinkObject(item, this.getUrlByPageId),
    ) || []
  }

  private redirect () : void {
    localStorage.setItem('geoTargeting', 'redirect')
  }

  private close () : void {
    this.geoTargetingVisible = false
    localStorage.setItem('geoTargeting', 'no-redirect')
    document.documentElement.style.setProperty('--scrollbar-width', '0px')
  }

  destroyed () {
    document.body.classList.remove('overflow-hidden')
    document.documentElement.style.setProperty('--scrollbar-width', '0px')
  }

  @Watch('geoTargetingVisible')
  private visibilityChanged () : void {
    document.body.classList[this.geoTargetingVisible ? 'add' : 'remove']('overflow-hidden')
  }
}
